import { IClusterDomInfo } from '../../../types/cluster/IClusterDomInfo';

const buildCluster = (): IClusterDomInfo => {
  const style = {
    backgroundPosition: '0 0',
    fontStyle: 'normal',
    fontWeight: 'bold',
    height: 30,
    textColor: '#fff',
    textDecoration: 'none',
    textLineHeight: 30,
    textSize: 12,
    width: 30,
  };

  return {
    cssClass: '',
    styles: [{ ...style }],
  };
};
export default buildCluster;
